import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';
import TablePositionCell from '@/components/core/Table/CustomCells/TablePositionCell';
import { PlayerRollCompetitionAwardWithRolled } from '@/models/roll-competition/awards';
import TableUser from '@/components/core/Table/CustomCells/TableUser';
import { getComputedColor, getMoneyOrAmount } from '@starsoft/common/utils';
import ValueWithCoinCell from '@/components/core/Table/CustomCells/ValueWithCoinCell';
import { WalletService } from '@starsoft/common/services';

export const rollCompetitionPrizesColumns: TableGridColumn<PlayerRollCompetitionAwardWithRolled>[] =
  [
    {
      field: 'place',
      headerName: 'table_position',
      renderCell: row => <TablePositionCell position={row?.place} />,
    },
    {
      field: 'player.username',
      headerName: 'table_username',
      renderCell: (row: PlayerRollCompetitionAwardWithRolled) => (
        <TableUser player={row?.player} />
      ),
    },
    {
      field: 'rolled',
      headerName: 'table_score',
      renderCell: row => (
        <p
          style={{
            color: getComputedColor('--primary-color'),
            fontWeight: 700,
          }}
        >
          {row?.rolled}
        </p>
      ),
    },
    {
      field: 'prize',
      headerName: 'table_prize',
      renderCell: row => (
        <ValueWithCoinCell
          coin={row?.coin}
          value={WalletService.maskCurrency({
            amount: getMoneyOrAmount(row?.prize),
            coin: row?.coin,
            hideSymbol: true,
          })}
        />
      ),
    },
  ];
